import ApiResponseBase from '../../../../../Base/Domain/ApiResponseBase';
import MembershipPaymentsSummaryModel from '../../MembershipPaymentsSummaryModel';

class GetMembershipPaymentDetailResponseModel extends ApiResponseBase {

  constructor(params) {

    super(params);

    if (typeof params === 'undefined' || params === null) {
      return;
    }

    this.PaymentsSummary = new MembershipPaymentsSummaryModel(params.paymentsSummary);

  }

}

export default GetMembershipPaymentDetailResponseModel;